import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Fancybox } from "@fancyapps/ui";
import axios from "axios";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DOMPurify from "dompurify";
import CTA from "../components/cta";
function PropertyDetails() {
const { id } = useParams();
const currentUrl = window.location.href;
const [formData, setFormData] = useState({ 
  agent_name: "",
  agent_phone: "",
  agent_email: "" ,
  agent_address: "" 
});
 const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.ae";

const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);
const [success, setSuccess] = useState("");
const [responseMsg, setResponseMsg] = useState(""); 
 const [property, setProperty] = useState(null); 
  const validate = () => {
  let err = {};

  if (!formData.agent_name.trim()) {
    err.agent_name = "Name is required";
  }

  if (!formData.agent_phone.trim()) {
    err.agent_phone = "Phone number is required";
  } else if (!/^[0-9+\s-]{7,15}$/.test(formData.agent_phone)) {
    err.agent_phone = "Invalid phone number";
  }

  if (!formData.agent_email) {
    err.agent_email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.agent_email)) {
    err.agent_email = "Invalid email address";
  }
 

  setErrors(err);

  return Object.keys(err).length === 0;
};
const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value
  });
};
 const handleSubmit = async (e) => {
  e.preventDefault();

  setSuccess("");

  if (!validate()) return;

  setLoading(true);

  try {
    const payload = {
      proref: property.title,
      emailto: property.agent_email,
      current_url: window.location.href,
      ...formData
    };

    const res = await axios.post(`${API}/api/EnquiryHandler.ashx`,
      JSON.stringify(payload),
      {
        headers: { "Content-Type": "application/json" }
      }
    );

   
setResponseMsg(res.data?.message || "Message sent successfully!");
    // reset form
    setFormData({ 
      agent_name: "",
      agent_phone: "",
      agent_email: "",
      agent_address: ""
    });

  } catch (err) {
    setResponseMsg("Something went wrong!");
  } finally {
    setLoading(false);
  }
};
  // ✅ Fetch API
  useEffect(() => {
    const fetchProperty = async () => {
      try {
        setLoading(true);

const res = await axios.post(`${API}/api/propertydetail.ashx`,
  {
    id: id   // ✅ correct
  },
  {
    headers: {
      "Content-Type": "application/json"
    }
  }
);
         setProperty(res.data.data[0]);
      } catch (error) {
        console.error("Error fetching property:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProperty();
  }, [id]);

  // ✅ Initialize Fancybox after component mounts
  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: false,
      Toolbar: {
        display: ["close"],
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, []); 
  useEffect(() => {
  if (property) {
    setFormData((prev) => ({
      ...prev,
      reference_number: property.reference_number,
      agent_address: `I would like to inquire about your property Nova Real Estate - "${property.title}". Please contact me at your earliest convenience.`
    }));
  }
}, [property]);
  if (!property) return <p>No property found</p>;
  return (
    <>
      {/* ==================== GALLERY ==================== */}
     <section className="flat-gallery-single">
  {(() => {
    const photos = [
      ...(property?.photos4 || []),
      ...(property?.photos5 || []),
    ]
      .filter((photo) => photo?.image)
      .map((photo, originalIndex) => ({
        ...photo,
        originalIndex,
        savedPosition: Number(photo.position),
      }))
      .sort((firstPhoto, secondPhoto) => {
        const firstPosition = Number.isFinite(firstPhoto.savedPosition)
          ? firstPhoto.savedPosition
          : Number.MAX_SAFE_INTEGER;
        const secondPosition = Number.isFinite(secondPhoto.savedPosition)
          ? secondPhoto.savedPosition
          : Number.MAX_SAFE_INTEGER;

        return firstPosition - secondPosition
          || firstPhoto.originalIndex - secondPhoto.originalIndex;
      });

    const mainImage = photos[0];
    const remaining = photos.slice(1);

    return (
      <>
        {/* MAIN IMAGE */}
        {property && (
  <div className="sticky-price-bar">
    <div className="sticky-left">
      <h4>{property.title}</h4>
      <p>
      {Number(property.bedrooms) === 0
    ? "Studio"
    : `${property.bedrooms} Beds`}{" "}
  • {property.bathrooms || property.No_of_Bathroom} Baths •{" "}
  {Number(property.size).toLocaleString()} SQFT
      </p>
    </div>

    <div className="sticky-right">
      <div className="price">
        AED {Number(property.price).toLocaleString()}
      </div>

      <a href="#contact" className="enquire-btn">
        Enquire Now
      </a>
    </div>
  </div>
)}
        {mainImage && (
          <div className="item1 box-img">
            <a
              href={`${mainImage.image}/w=900,sharpen=1`}
              data-fancybox="gallery"
              className="box-img"
            >
              <img
                src={`${mainImage.image}/w=941,sharpen=1`}
                alt="main-property"
              />
            </a>

            <div className="box-btn">
              <a
                href={`${mainImage.image}/w=900,sharpen=1`}
                data-fancybox="gallery"
                className="tf-btn primary fullborderradius"
              >
                View All Photos
              </a>
            </div>
          </div>
        )}

        {/* SHOW FIRST 4 ONLY */}
        {remaining.slice(0, 4).map((img, index) => (
          <a
            key={img.image || index}
            href={`${img.image}/w=900,sharpen=1`}
            className={`item${index + 2} box-img`}
            data-fancybox="gallery"
          >
            <img
              src={`${img.image}/w=468,sharpen=1`}
              alt={`gallery-${index}`}
            />
          </a>
        ))}

        {/* HIDDEN REST (still in Fancybox) */}
        {remaining.slice(4).map((img, index) => (
          <a
            key={`hidden-${img.image || index}`}
            href={`${img.image}/w=900,sharpen=1`}
            data-fancybox="gallery"
            style={{ display: "none" }}
          >
            <img src={`${img.image}/w=468,sharpen=1`} alt="" />
          </a>
        ))}
      </>
    );
  })()}
</section>
  <section className="flat-section-v3 flat-property-detail">
    <div className="container">
      <div className="row">
        <div className="col-xl-8 col-lg-7">
          <div className="single-property-element single-property-desc">
            <h1 className="title">{property.title}</h1>
            <p className="p_address">
              {property.property_type} for {property.offering_type} in {property.sub_community}, {property.community}, {property.city} - United Arab Emirates
            </p>
            <h4 className="title fw-6" style={{ marginBottom: 5 }}>
              AED {Number(property.price).toLocaleString()}
            </h4>
            <hr />
            <h5 className="fw-6 title">Description</h5>
            <p className="text-variant-1"></p>
          <div
  className="property-description"
  dangerouslySetInnerHTML={{
    __html: DOMPurify.sanitize(property.description_en).replace(/&nbsp;/g, " "),
  }}
/>
            
          </div>
          <div className="single-property-element single-property-feature">
            <h5 className="title fw-6">Property Details</h5>
           <div className="property-grid">
  <div className="property-item">
    <i className="fa-solid fa-id-card" />
    <div>
      <strong>Property Id:</strong> {property.reference_number}
    </div>
  </div>
  <div className="property-item">
    <i className="fa-solid fa-tag" />
    <div>
      <strong>Listing Type:</strong> For {property.offering_type}
    </div>
  </div>
  <div className="property-item">
    <i className="fa-solid fa-building" />
    <div>
      <strong>Property Type:</strong> {property.property_type}
    </div>
  </div>
  <div className="property-item">
    <i className="fa-solid fa-bed" />
    <div>
      <strong>Bedrooms:</strong> {Number(property.bedrooms) === 0
    ? "Studio"
    : `${property.bedrooms} Beds`}
    </div>
  </div>
  <div className="property-item">
    <i className="fa-solid fa-bath" />
    <div>
      <strong>Bathrooms:</strong> {property.No_of_Bathroom} Bathrooms
    </div>
  </div>
{Number(property.parking) > 0 && (
  <div className="property-item">
    <i className="fa-solid fa-car" />
    <div>
      <strong>Garage:</strong> {property.parking}
    </div>
  </div>
)}
   <div className="property-item">
    <i className="fa-solid fa-ruler-combined" />
    <div>
      <strong>Size:</strong> {Number(property.size).toLocaleString()} SQFT
    </div>
  </div>
 
  <div className="property-item">
    <i className="fa-solid fa-money-bill-wave" />
    <div>
      <strong>Price:</strong> AED {Number(property.price).toLocaleString()}
    </div>
  </div>
 {property.sub_community &&
 property.sub_community !== "NULL" &&
 property.sub_community.trim() !== "" && (
  <div className="property-item">
    <i className="fa-solid fa-map-location-dot" />
    <div>
      <strong>Sub-Community:</strong> {property.sub_community}
    </div>
  </div>
)}
  <div className="property-item">
    <i className="fa-solid fa-users" />
    <div>
      <strong>Community:</strong> {property.community}
    </div>
  </div>
  <div className="property-item">
    <i className="fa-solid fa-city" />
    <div>
      <strong>City:</strong> {property.city}
    </div>
  </div>
  <div className="property-item">
    <i className="fa-solid fa-flag" />
    <div>
      <strong>Country:</strong> United Arab Emirates
    </div>
  </div>
   {property.permitno &&
 property.permitno !== "NULL" &&
 property.permitno.trim() !== "" && (
  <div className="property-item">
    <i className="fa-solid fa-file-shield" />
    <div>
      <strong>Permit No.:</strong> {property.permitno}
    </div>
  </div>
)}  
{property.ORN &&
 property.ORN !== "NULL" &&
 property.ORN.trim() !== "" && (
  <div className="property-item">
    <i className="fa-solid fa-id-badge" />
    <div>
      <strong>ORN:</strong> {property.ORN}
    </div>
  </div>
)}    
{property.ORN &&
 property.ORN !== "NULL" &&
 property.ORN.trim() !== "" && (
  <div className="property-item">
    <i className="fa-solid fa-id-card-clip" />
    <div>
      <strong>BRN:</strong> {property.BRN}
    </div>
  </div>
)}   
</div>

          </div>
          <div className="single-property-element single-property-feature">
            <h5 className="title fw-6">Amenities</h5>
            <div className="wrap-feature">
              <div className="property-gridame" style={{ width: "100%" }}>
                 <div className="property-item">
  <img
    src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/43617564-a550-43af-7e79-0d247cd95100/w=30,sharpen=1"
    style={{ width: 29 }}
  />
  <div style={{ paddingTop: 2, paddingLeft: 11 }}>Balcony</div>
</div>
{property.amenities?.map((item, index) => (
    <div className="property-item" key={index}>
      <img src={item.image+'/w=30,sharpen=1'} alt={item.name} />
      <div style={{ paddingTop: 2, paddingLeft: 11 }}>{item.name}</div>
    </div>
  ))} 
              </div>
            </div>
          </div>
          
          <div className="single-property-element single-property-map">
            <h5 className="title fw-6">Map location</h5>
           <div
  className="map-container"
  dangerouslySetInnerHTML={{
    __html: DOMPurify.sanitize(property.geopoints, {
      ADD_TAGS: ["iframe"],
      ADD_ATTR: ["src", "width", "height", "style"]
    })
  }}
/>

          </div>
        </div>
        <div className="col-xl-4 col-lg-5" id="contact">
          <div className="single-sidebar fixed-sidebar">
            <div className="widget-box single-property-contact">
              <h5 className="title fw-6">Contact Agent</h5>
              <div className="box-avatar">
                <div className="avatar avt-100 round">
                  <img
                   src={property.agent_img+'/w=100,sharpen=1'} alt={property.agent_name}
                  />
                </div>
                <div className="info">
                  <h6 className="name">{property.agent_name}</h6>
                  <ul className="list">
                    <li className="d-flex align-items-center gap-4 text-variant-1">
                      <i className="icon icon-phone" />
                      {property.agent_phone}
                    </li>
                    <li className="d-flex align-items-center gap-4 text-variant-1">
                      <i className="icon icon-mail" />
                      {property.agent_email}
                    </li>
                  </ul>
                </div>
              </div>
              <form  className="contact-form" onSubmit={handleSubmit}>
                <input
                  type="hidden"
                  name="proref"
                  id="proref"
                  className="input"
                  defaultValue={property.reference_number}
                  style={{ width: "100%" }}
                /> 
                <input
                  type="hidden"
                  name="emailto"
                  id="emailto"
                  className="input"
                  defaultValue={property.agent_email}
                  style={{ width: "100%" }}
                /> 
                <div className="ip-group">
                  <input
                    type="text"
                    name="agent_name"
                    id="agent_name"
                    value={formData.agent_name}
                    onChange={handleChange}
                    placeholder="Name"
                    className={`form-control ${errors.agent_name ? "input-error" : ""}`}
                    required=""
                  />
                   {errors.agent_name && (
    <p className="error-text">{errors.agent_name}</p>
  )}
                </div>
                <div className="ip-group">
                 <PhoneInput
  country={"ae"}   // default UAE 🇦🇪
  value={formData.agent_phone}
  onChange={(phone) =>
    setFormData({ ...formData, agent_phone: phone })
  }
  inputClass="form-control phone-input"
  containerClass="phone-container"
  enableSearch={true}
  placeholder="Enter phone number"
/>
                   {errors.agent_phone && (
    <p className="error-text">{errors.agent_phone}</p>
  )}
                </div>
                <div className="ip-group">
                  <input
                    type="email"
                    name="agent_email"
                    id="agent_email"
                    value={formData.agent_email}
                    onChange={handleChange}
                    placeholder="Email"
                    className={`form-control ${errors.agent_phone ? "input-error" : ""}`}
                    required=""
                  />
                   {errors.agent_email && (
    <p className="error-text">{errors.agent_email}</p>
  )}
                </div>
                <div className="ip-group">
                 <textarea
  name="agent_address"
  id="agent_address"
  rows={4}
  placeholder="Message"
  value={formData.agent_address}
  onChange={handleChange}
  className="form-control"
  required
/>
                  <p className="error">{errors.agent_address}</p>
                </div>
                <div className="ip-group">
                  {responseMsg && (
  <div className="success-text">
    {responseMsg}
  </div>
)}
                </div>
                <button
  type="submit"
  className="tf-btn-1 btn-view primary hover-btn-view w-100"
  disabled={loading}
>
  {loading ? "Sending..." : "Submit"}
  <span className="icon icon-arrow-right2" />
</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

      {/* ==================== DETAILS ==================== */}
     <CTA/>
    </>
  );
}

export default PropertyDetails;
